import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Quotes, Star } from "@phosphor-icons/react";
import { useLanguage } from "@/context/LanguageContext";

export default function TestimonialsSection() {
  const { t } = useLanguage();
  const items = t.testimonials.items;
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % items.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [items.length]);

  return (
    <section id="testimonios" className="py-24 md:py-32 bg-[#0A0A0A]" data-testid="testimonials-section">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="mb-16">
          <p className="text-xs uppercase tracking-[0.25em] text-[#FFD700] mb-4 font-light">{t.testimonials.overline}</p>
          <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-5xl font-light text-white tracking-tight">{t.testimonials.title}</h2>
        </motion.div>

        <div className="relative min-h-[280px]">
          {items.map((item, i) => (
            <motion.div key={i} initial={false} animate={{ opacity: i === active ? 1 : 0, y: i === active ? 0 : 20 }} transition={{ duration: 0.6 }} className={`absolute inset-0 flex flex-col items-center ${i === active ? "pointer-events-auto" : "pointer-events-none"}`} data-testid={`testimonial-${i}`}>
              <Quotes size={48} weight="fill" className="text-[#FFD700]/30 mb-6" />
              <p className="font-['Cormorant_Garamond'] text-xl md:text-2xl lg:text-3xl font-light text-white leading-relaxed max-w-3xl italic mb-8">"{item.text}"</p>
              <div className="flex gap-1 mb-4">{[...Array(5)].map((_, idx) => <Star key={idx} size={16} weight="fill" className="text-[#FFD700]" />)}</div>
              <p className="text-white font-medium text-sm">{item.name}</p>
              <p className="text-zinc-500 text-xs uppercase tracking-wider mt-1">{item.role}</p>
            </motion.div>
          ))}
        </div>

        <div className="flex justify-center gap-3 mt-8" data-testid="testimonial-dots">
          {items.map((_, i) => (
            <button key={i} onClick={() => setActive(i)} className={`w-2 h-2 rounded-full transition-all duration-300 ${i === active ? "bg-[#FFD700] w-6" : "bg-white/20 hover:bg-white/40"}`} data-testid={`testimonial-dot-${i}`} />
          ))}
        </div>
      </div>
    </section>
  );
}
